import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/mobileLogin',
      component: () => import('@/components/mobileLogin/mobileLogin'), //移动端登录
      name: 'mobileLogin'
    },
    {
      path: '/mobileLogin_userName',
      component: () => import('@/components/mobileLogin/mobileLogin_userName/mobileLogin_userName'), //移动端<用户协议>
      name: 'mobileLogin_userName'
    },
    {
      path: '/mobile_privacy',
      component: () => import('@/components/mobileLogin/mobile_privacy/mobile_privacy'), //移动端<隐私协议>
      name: 'mobile_privacy'
    },
    {
      path: '/app_privacy',
      component: () => import('@/components/mobileLogin/mobile_privacy/app_privacy'), //移动端<隐私协议>
      name: 'app_privacy'
    },
    
    // {
    //   path: '/moAccount',
    //   component: () => import('@/components/accountMobile/account'),
    //   name: '/moAccount',
    //   meta: {
    //     title: '确认订单',
    //     requireAuth: true
    //   }
    // },
    {
      path: '/resetPassWord',
      component: () => import('@/components/mobileLogin/resetPassWord/resetPassWord'), //移动端重置密码
      name: 'resetPassWord',
    },
    {
      path: '/mobileRegister',
      component: () => import('@/components/mobileLogin/mobileRegister/mobileRegister'), //移动端注册
      name: 'mobileRegister',
    },
    {
      path: '/mobilePersonalCenter',
      component: () => import('@/components/mobilePage/mHome/mHome'), //移动端个人信息
      name: 'mHome',
      children:[
        {
          path: '/mobilePersonalCenter',
          component: () => import('@/components/mobilePage/mobilePersonalCenter/mobilePersonalCenter'), //移动端个人中心
          name: 'mobilePersonalCenter',
          meta: {
            title: "个人中心",
            // requireAuth: true
          }
        },
        // {
        //   path: "/goodsShop",
        //   component: () => import("@/components/mobilePage/goods-shop/goods-shop"),
        //   name: 'goodsShop',
        //   meta: {
        //     title: "购物车",
        //     requireAuth: true
        //   }
        // },
        {
            path: "/goodsShop",
            component: () => import("@/components/mobilePage/mCar/mCar"),
            name: 'goodsShop',
            meta: {
              title: "购物车",
              requireAuth: true
            }
          },
      ]
    },
    {
      path: '/mobilePersonalInfo',
      component: () => import('@/components/mobilePage/mobilePersonalInfo/mobilePersonalInfo'), //移动端个人信息
      name: 'mobilePersonalInfo',
    },
    {
      path: '/mOrderList', //移动端订单列表
      component: () => import('@/components/mobilePage/mobileOrder/mOrderList'), 
      name: 'mOrderList',
    },
    {
        path: '/mOrderSearch', //移动端订单搜索
        component: () => import('@/components/mobilePage/mobileOrder/mOrderSearch'), 
        name: 'mOrderSearch',
    },
    {
        path: '/mSearchResult', //移动端订单搜索结果
        component: () => import('@/components/mobilePage/mobileOrder/mSearchResult'), 
        name: 'mSearchResult',
    },
    {
      path: '/mLogistics', //移动端物流详情
      component: () => import('@/components/mobilePage/mobileOrder/mLogistics'), 
      name: 'mLogistics',
    },
    {
      path: '/mOrderDto', //移动端订单详情
      component: () => import('@/components/mobilePage/mOrderDto/mOrderDto'), 
      name: 'mOrderDto',
    },
    {
        path: '/mRefoundOrderDto', //移动端退款详情
        component: () => import('@/components/mobilePage/mOrderDto/mRefoundOrderDto'), 
        name: 'mRefoundOrderDto',
      },
    {
        path: '/mobileApply', //移动端选择售后
        component: () => import('@/components/mobilePage/mobileApply/mobileApply'), 
        name: 'mobileApply',
    },
    {
        path: '/mobileInvoiceInfo', //移动端发票详情
        component: () => import('@/components/mobilePage/mOrderDto/mobileInvoiceInfo'), 
        name: 'mobileInvoiceInfo',
    },
    {
      path: '/mMyPoints', //移动端积分
      component: () => import('@/components/mobilePage/mobileHeaderJump/mMyPoints'), 
      name: 'mMyPoints',
    },
    {
      path: '/mMyPointsRecord', //移动端积分兑换记录
      component: () => import('@/components/mobilePage/mobileHeaderJump/mMyPointsRecord'), 
      name: 'mMyPointsRecord',
    },
    {
      path: '/mMyTask', //移动端积分
      component: () => import('@/components/mobilePage/mobileHeaderJump/mMyTask'), 
      name: 'mMyTask',
    },
    {
      path: '/mMyPointsRules', //移动端积分规则
      component: () => import('@/components/mobilePage/mobileHeaderJump/mMyPointsRules'), 
      name: 'mMyPointsRules',
    },
    {
      path: '/mPointsDetail',
      component: () => import('@/components/mobilePage/mPointsDetail/mPointsDetail'),
      name: 'mPointsDetail',
      meta: {
        title: '积分详情',
        requireAuth: true
      }
    },
    {
      path: '/mMyFavourite', //移动端收藏
      component: () => import('@/components/mobilePage/mobileHeaderJump/mMyFavourite'), 
      name: 'mMyFavourite',
    },
    {
      path: '/mExchange', //移动端收藏
      component: () => import('@/components/mobilePage/mExchange/mExchange'), 
      name: 'mExchange',
    },
    // {
    //   path: '/settlement', //移动端支付
    //   component: () => import('@/components/mobilePage/settlement/settlement'), 
    //   name: 'settlement',
    //   meta: {
    //     title: '确认订单',
    //     requireAuth: true
    //   }
    // },
    {
        path: '/settlement', //移动端支付
        component: () => import('@/components/mobilePage/mCar/components/settlement'), 
        name: 'settlement',
        meta: {
          title: '确认订单',
          requireAuth: true
        }
      },
      {
          path: '/mSampleBook', //样书申请
          component: () => import('@/components/mobilePage/mCar/components/mSampleBook'), 
          name: 'mSampleBook',
          meta: {
            title: '确认申请',
            requireAuth: true
          }
        },
    {
      path: '/invlist', //移动端发票列表
      component: () => import('@/components/mobilePage/mobileInvoice/invoiceList'), 
      name: 'invlist',
      meta: {
        title: '确认订单',
        requireAuth: true
      }
    },
    {
      path: '/addInv', //移动端新增发票
      component: () => import('@/components/mobilePage/mobileInvoice/addInvoice'), 
      name: 'addInv',
      meta: {
        title: '确认订单',
        requireAuth: true
      }
    },
    {
      path: '/mMyExchange', //移动端兑换
      component: () => import('@/components/mobilePage/mobileHeaderJump/mMyExchange'), 
      name: 'mMyExchange',
    },
    {
      path: '/mMyRead', //移动端阅读
      component: () => import('@/components/mobilePage/mobileHeaderJump/mMyRead'), 
      name: 'mMyRead',
    },
    {
      path: '/mMyQuan', //移动端读者圈
      component: () => import('@/components/mobilePage/mobileHeaderJump/mMyQuan'), 
      name: 'mMyQuan',
    },
    {
      path: '/mobMyFootPrint',
      component: () => import('@/components/mobilePage/myFootPrint/myFootPrint'), //移动端我的足迹
      name: 'mobMyFootPrint',
    },
    {
      path: '/class/mInvitationCode',
      name:'mJoinClass',
      component: () => import('@/components/mobilePage/mJoinClass/mJoinClass'),
      meta: {
        title:"我学的课",
        requireAuth:true,
      }
    },// 移动端加入班级
    {
        path: '/mobMyCourse',
        component: () => import('@/components/mobilePage/myCourse/myCourse'), //移动端我教的课
        name: 'mobMyCourse',
        meta: {
            title:"我教的课",
            requireAuth:true,
          }
      },
      {
        path: '/mobMyCurriculum',
        component: () => import('@/components/mobilePage/myCourse/curriculum'), //移动端我的课表
        name: 'mobMyCurriculum',
        meta: {
            title:"我的课表",
            requireAuth:true,
          }
      },
      {
        path: '/mobEditCurriculum',
        component: () => import('@/components/mobilePage/myCourse/editCurriculum'), //移动端我教的课--编辑
        name: 'mobEditCurriculum',
        meta: {
            title:"修改课表",
            requireAuth:true,
          }
        
      },
      {
        path: '/importCurriculum',
        component: () => import('@/components/mobilePage/myCourse/importCurriculum'), //移动端导入课表
        name: 'importCurriculum',
        meta: {
            title:"导入课表",
            requireAuth:true,
          }
      },
      {
        path: '/importStudent',
        component: () => import('@/components/mobilePage/myCourse/importStudent'), //移动端导入学生
        name: 'importStudent',
        meta: {
            title:"导入学生",
            requireAuth:true,
          }
      },
      {
        path: '/mobAddCourse',
        component: () => import('@/components/mobilePage/myCourse/addCourse'), //移动端添加课程
        name: 'mobAddCourse',
        meta: {
            title:"添加课程",
            requireAuth:true,
          }
      },
      {
        path: '/mobCreateCourse',
        component: () => import('@/components/mobilePage/myCourse/createCourse'), //移动端创建课程
        name: 'mobCreateCourse',
        meta: {
            title:"创建课程",
            requireAuth:true,
          }
      },
      {
        path: '/mobAddClassSuccess',
        component: () => import('@/components/mobilePage/myCourse/addClassSuccess'), //移动端添加课程
        name: 'mobAddClassSuccess',
        meta: {
            title:"班级邀请",
            requireAuth:true,
          }
      },
      {
        path: '/mobBatchDeleteClass',
        component: () => import('@/components/mobilePage/myCourse/batchDeleteClass'), //移动端批量删除班级
        name: 'mobBatchDeleteClass',
        meta: {
            title:"删除班级",
            requireAuth:true,
          }
      },
      {
        path: '/mobSortClass',
        component: () => import('@/components/mobilePage/myCourse/sortClass'), //移动端班级排序
        name: 'mobSortClass',
        meta: {
            title:"班级排序",
            requireAuth:true,
          }
      },
      {
        path: '/mobsearchCourseWare',
        component: () => import('@/components/mobilePage/myCourse/searchCourseWare'), //移动端课件搜索
        name: 'mobsearchCourseWare',
        meta: {
            title:"搜索课件",
            requireAuth:true,
          }
      },
      {
        path: '/mobsearchHomeWork',
        component: () => import('@/components/mobilePage/myCourse/searchHomeWork'), //移动端作业搜索
        name: 'mobsearchHomeWork',
        meta: {
            title:"搜索作业",
            requireAuth:true,
          }
      },
      {
        path: '/mobatchDeleteHomeWork',
        component: () => import('@/components/mobilePage/myCourse/batchDeleteHomeWork'), //移动端批量删除作业
        name: 'mobatchDeleteHomeWork',
        meta: {
            title:"删除作业",
            requireAuth:true,
          }
      },
      {
        path: '/mobaddCourseWare',
        component: () => import('@/components/mobilePage/myCourse/addCourseWare'), //移动端上传
        name: 'mobaddCourseWare',
        meta: {
            title:"添加课件",
            requireAuth:true,
          }
      },
      {
        path: '/mobdiscussDetail',
        component: () => import('@/components/mobilePage/myCourse/discussDetail'), //讨论详情
        name: 'mobdiscussDetail',
        meta: {
            title:"讨论详情",
            requireAuth:true,
          }
      },
      {
        path: '/mobanswerDetail',
        component: () => import('@/components/mobilePage/myCourse/answerDetail'), //抢答详情
        name: 'mobanswerDetail',
        meta: {
            title:"抢答详情",
            requireAuth:true,
          }
      },
      {
        path: '/mobreleaseAnswer',
        component: () => import('@/components/mobilePage/myCourse/releaseAnswer'), //发布抢答
        name: 'mobreleaseAnswer',
        meta: {
            title:"发布抢答",
            requireAuth:true,
          }
      },
      {
        path: '/mobreleaseDiscuss',
        component: () => import('@/components/mobilePage/myCourse/releaseDiscuss'), //发布讨论
        name: 'mobreleaseDiscuss',
        meta: {
            title:"发布讨论",
            requireAuth:true,
          }
      },
      {
        path: '/mobatchDeleteCourseWare',
        component: () => import('@/components/mobilePage/myCourse/batchDeleteCourseWare'), //移动端批量删除课件
        name: 'mobatchDeleteCourseWare',
        meta: {
            title:"课件管理",
            requireAuth:true,
          }
      },
      {
        path: '/mobaddHomeWork',
        component: () => import('@/components/mobilePage/myCourse/addHomeWork'), //移动端上传作业
        name: 'mobaddHomeWork',
        meta: {
            title:"发布作业",
            requireAuth:true,
          }
      },
      {
        path: '/mobsortCourseWare',
        component: () => import('@/components/mobilePage/myCourse/sortCourseWare'), //移动端作业排序
        name: 'mobsortCourseWare',
        meta: {
            title:"课件管理",
            requireAuth:true,
          }
      },
      {
        path: '/mobClassDetail',
        component: () => import('@/components/mobilePage/myCourse/classDetail'), //移动端班级详情
        name: 'mobClassDetail',
        meta: {
            title:"班级详情",
            requireAuth:true,
          }
      },
    {
        path: '/mPublicClass',
        component: () => import('@/components/mobilePage/mobilePublicClass/mPublicClass'), //移动端我的公开课
        name: 'mPublicClass',
    },
    {
        path: '/mCalendar',
        component: () => import('@/components/mobilePage/mobilePublicClass/mCalendar'), //移动端我的公开课日历
        name: 'mCalendar',
    },
    {
      path: '/mobileLogin_userName',
      component: () => import('@/components/mobileLogin/mobileLogin_userName/mobileLogin_userName'), //移动端我的<用户协议>
      name: 'mobileLogin_userName',
    },
    {
      path: "/msearch",
      component: () => import('@/components/mobilePage/msearch/msearch'),
      name: "msearch",
      meta: {
        title: "搜索",
        // requireAuth: true
      },
      children:[
        {
          path: "options",
          component: () => import('@/components/mobilePage/msearch/search-options'),
          name: "search-options",
          meta: {
            title: "搜索-配置",
          }
        },
        {
          path: "goodsresult",
          component: () => import('@/components/mobilePage/msearch/search-goods-result'),
          name: "search-goods-result",
          meta: {
            title: "搜索-结果",
          }
        }
      ]
    },
    // {
    //   path: "options",
    //   component: () => import('@/components/mobilePage/msearch/search-options'),
    //   name: "search-options",
    //   meta: {
    //     title: "搜索-配置",
    //   }
    // },
    // {
    //   path: "goodsresult",
    //   component: () => import('@/components/mobilePage/msearch/search-goods-result'),
    //   name: "search-goods-result",
    //   meta: {
    //     title: "搜索-结果",
    //   }
    // },


    {
      path: '/addressManage',
      component: () => import('@/components/mobilePage/addressManage/addressManage'), //移动端地址管理
      name: 'addressManage',
    },
    {
      path: '/addAddress',
      component: () => import('@/components/mobilePage/addAddress/addAddress'), //移动端新添加地址
      name: 'addAddress',
    },
    {
      path: '/aboutUs',
      component: () => import('@/components/mobilePage/aboutUs/aboutUs'), //关于我们
      name: 'aboutUs',
    },
    {
      path: '/settings',
      component: () => import('@/components/mobilePage/mobileSettings/mobileSettings'), // 移动端设置
      name: 'settings',
    },
    {
        path: '/mobileAccount',
        component: () => import('@/components/mobilePage/mobileSettings/components/mobileAccount'), // 移动端账号与安全
        name: 'mobileAccount',
    },
    {
        path: '/forgetPassword',
        component: () => import('@/components/mobileLogin/forgetPassword'), // 移动端忘记密码
        name: 'forgetPassword',
    },
    {
        path: '/mobileUpdatePsw',
        component: () => import('@/components/mobilePage/mobileSettings/components/updatePsw'), // 移动端修改密码
        name: 'mobileUpdatePsw',
    },
    {
        path: '/accountBind',
        component: () => import('@/components/mobilePage/mobileSettings/components/accountBind'), // 移动端账号绑定
        name: 'accountBind',
      },
    {
      path: '/mobileBind',
      component: () => import('@/components/mobilePage/mobileSettings/components/mobileBind'), // 移动端手机绑定
      name: 'mobileBind',
    },
    {
      path: '/emailBind',
      component: () => import('@/components/mobilePage/mobileSettings/components/emailBind'), // 移动端邮箱绑定
      name: 'emailBind',
    },
    {
      path: '/updateEmail_first',
      component: () => import('@/components/mobilePage/mobileSettings/components/updateEmail_first'), // 移动端修改邮箱号
      name: 'updateEmail_first',
    },
    {
      path: '/updateEmail_second',
      component: () => import('@/components/mobilePage/mobileSettings/components/updateEmail_second'), // 移动端修改邮箱号
      name: 'updateEmail_second',
    },
    {
      path: '/updatePhone_first',
      component: () => import('@/components/mobilePage/mobileSettings/components/updatePhone_first'), // 移动端修改手机号
      name: 'updatePhone_first',
    },
    {
      path: '/updatePhone_second',
      component: () => import('@/components/mobilePage/mobileSettings/components/updatePhone_second'), // 移动端修改手机号
      name: 'updatePhone_second',
    },
    {
      path: '/exchangeBag',
      component: () => import('@/components/mobilePage/exchangeBag/exchangeBag'), // 移动端兑换增值资源
      name: 'exchangeBag',
    },
    {
      path: '/purchasedRescource',
      component: () => import('@/components/mobilePage/purchasedRescource/purchasedRescource'), // 移动端已购资源
      name: 'purchasedRescource',
    },
    {
      path: '/mobileSearch',
      component: () => import('@/components/mobilePage/purchasedRescource/mobileSearch'), // 移动端已购资源搜索页
      name: 'mobileSearch',
    },
    {
      path: '/answerQuestionList',
      component: () => import('@/components/mobilePage/answerQuestionList/answerQuestionList'), // 移动端答题列表
      name: 'answerQuestionList',
    },
    {
      path: '/servicePackageList',
      component: () => import('@/components/mobilePage/servicePackageList/servicePackageList'), // 移动端我的增值服务包
      name: 'servicePackageList',
    },
    {
      path: '/mServicePackageDetail',
      component: () => import('@/components/mobilePage/servicePackageList/servicePackageDetail'), // 移动端增值服务包详情
      name: 'servicePackageDetail',
    },
    {
      path: '/lxkf',
      component: () => import('@/components/mobilePage/lxkf/lxkf'), // 移动端联系客服
      name: 'lxkf',
    },
    {
      path: '/mPersonalMsg',
      component: () => import('@/components/mobilePage/msgCenter/mPersonalMsg'), // 移动端消息中心
      name: 'mPersonalMsg',
    },
    {
        path: '/mPersonalSysMsg',
        component: () => import('@/components/mobilePage/msgCenter/mPersonalSysMsg'), // 移动端系统消息
        name: 'mPersonalSysMsg',
      },
    {
        path: '/mPersonalHdMsg',
        component: () => import('@/components/mobilePage/msgCenter/mPersonalHdMsg'), // 移动端活动优惠
        name: 'mPersonalHdMsg',
    },
    {
        path: '/mPersonalWlMsg',
        component: () => import('@/components/mobilePage/msgCenter/mPersonalWlMsg'), // 移动端交易物流
        name: 'mPersonalWlMsg',
    },
    {
        
      path: '/mPersonalMsgDetail',
      component: () => import('@/components/mobilePage/msgCenter/mPersonalMsgDetail'), // 移动端消息详情
      name: 'mPersonalMsgDetail',
    },
    {
      path: '/',
      component: () => import('@/components/login/login'),
      name: 'home',
      redirect: '/login',
      meta: {
        requireAuth: false
      },
      children: [
        {
          path: '/headers',
          component: () => import('@/components/headers/headers')
        }, {
          path: '/banners',
          component: () => import('@/components/banner/banner')
        }, {
          path: '/footers',
          component: () => import('@/components/footers/footers')
        }
      ]
    }, 
    // {
    //   path: '/bimaskmore',
    //   component: () => import('@/components/bimask/bimaskmore'),
    //   name: 'bimaskmore'
    // }, {
    //   path: '/asking',
    //   component: () => import('@/components/asking/asking'),
    //   name: 'asking'
    // }, {
    //   path: '/askdetail',
    //   component: () => import('@/components/asking/askdetail'),
    //   name: 'askdetail'
    // }, {
    //   path: '/askprice',
    //   component: () => import('@/components/asking/askprice'),
    //   name: 'askprice'
    // }, {
    //   path: '/askanswer',
    //   component: () => import('@/components/asking/askanswer'),
    //   name: 'askanswer'
    // }, 
    {
      path: '/payfinish',
      component: () => import('@/components/payfinish/payfinish'),
      name: 'payfinish',
      meta: { title: '支付完成', requireAuth: true }
    }, {
      path: '/orderDetail',
      component: () => import('@/components/orderDetail/orderDetail'),
      name: 'orderDetail',
      meta: { title: '订单详情', requireAuth: true }
    }, {
      path: '/refoundOrderDetail',
      component: () => import('@/components/orderDetail/refoundOrderDetail'),
      name: 'refoundOrderDetail',
      meta: { title: '售后详情', requireAuth: true }
    }, {
      path: '/orderPostSale',
      component: () => import('@/components/orderDetail/orderPostSale'),
      name: 'orderPostSale',
      meta: { title: '申请售后', requireAuth: true }
    },
    {
      path: '/payAgain',
      component: () => import('@/components/orderDetail/payAgain'),
      name: 'payAgain',
      meta: { title: '再次购买', requireAuth: true }
    },
    {
      path: '/changePassword',
      component: () => import('@/components/personal/changePassword/changePassword'),
      name: 'changePassword',
      meta: { title: '重置密码', requireAuth: true }
    },
    {
      path: '/changeMailBox',
      component: () => import('@/components/personal/changeMailBox/changeMailBox'),
      name: 'changeMailBox',
      meta: { title: '修改邮箱', requireAuth: true }
    },
    {
      path: '/changeMailBox-second',
      component: () => import('@/components/personal/changeMailBox/changeMailBox-second'),
      name: 'changeMailBox-second',
      meta: { title: '修改邮箱', requireAuth: true }
    },
    {
      path: '/changeMailBox-third',
      component: () => import('@/components/personal/changeMailBox/changeMailBox-third'),
      name: 'changeMailBox-third',
      meta: { title: '修改邮箱', requireAuth: true }
    },
    {
      path: '/changeTel',
      component: () => import('@/components/personal/changeTel/changeTel'),
      name: 'changeTel',
      meta: { title: '手机绑定', requireAuth: true }
    },
    {
      path: '/changeTel-second',
      component: () => import('@/components/personal/changeTel/changeTel-second'),
      name: 'changeTel-second',
      meta: { title: '手机绑定', requireAuth: true }
    },
    {
      path: '/changeTel-third',
      component: () => import('@/components/personal/changeTel/changeTel-third'),
      name: 'changeTel-third',
      meta: { title: '手机绑定', requireAuth: true }
    },
    // {
    //   path: '/confirmReceive',
    //   component: () => import('@/components/orderDetail/confirmReceive'),
    //   name: 'confirmReceive',
    //   meta: { title: '确认收货', requireAuth: true }
    // },
    {
      path: '/comment',
      component: () => import('@/components/orderDetail/comment'),
      name: 'comment',
      meta: { title: '评论', requireAuth: true }
    },
    {
      path: '/login',
      component: () => import('@/components/login/login'),
      name: 'Login',
      meta: {
        title: '欢迎登录',
        requireAuth: false,
        jumpAuth: true
      }
    },
    {
      path: '/register',
      component: () => import('@/components/register/register'),
      name: 'Register',
      meta: {
        title: '欢迎注册',
        requireAuth: false
      }
    },
    {
      path: '/agreement',
      component: () => import('@/components/register/agreement'),
      name: 'agreement',
      meta: {
        title: '用户注册协议',
        requireAuth: false
      }
    },
    {
      path: '/userAgreement',
      component: () => import('@/components/register/userAgreement'),
      name: 'userAgreement',
      meta: {
        title: '用户协议',
        requireAuth: false
      }
    },
    {
      path: '/privacyPolicy',
      component: () => import('@/components/register/privacyPolicy'),
      name: 'privacyPolicy',
      meta: {
        title: '隐私政策',
        requireAuth: false
      }
    },
    {
      path: '/personal',
      component: () => import('@/components/personal/personal'),
      name: 'personal',
      redirect: '/personalbar',
      meta: {
        title: '个人中心',
        requireAuth: true
      },
      children:[
        {
          path:'/personalbar',
          component:()=>import('@/components/personal/personalbar'),
          meta: {
            title: '个人中心',
            requireAuth: true
          },
          redirect: '/personalHome',
          children: [
            {
              path:'/personalReadingNotes',
              name:'personalReadingNotes',
              component:()=>import('@/components/personal/personalReadingNotes/personalReadingNotes'),
              meta: {
                title: '我的阅读',
                requireAuth: true
              }
            },
            {
              path:'/servicePackageDetail',
              component:()=>import('@/components/personal/servicePackageDetailsList/servicePackageDetailsList'),
              meta: {
                title: '增值服务包',
                requireAuth: true
              }
            },
              {
                path: '/personalHome',
                component: () => import('@/components/personal/personalHome'),
                name: 'personalHome',
                meta: {
                  title: '个人中心',
                  requireAuth: true
                }
              },
              {
                path: '/personalInfo',
                component: () => import('@/components/personal/personalInfo'),
                name: 'personalInfo',
                meta: {
                  title: '个人中心',
                  requireAuth: true
                }
              },
              {
                path: '/personalMsg',
                component: () => import('@/components/personal/personalMsg/personalMsg'),
                name: 'personalMsg',
                meta: {
                  title: '消息中心',
                  requireAuth: true
                }
              },
              {
                path: '/msg',
                component: () => import('@/components/personal/personalMsg/msg'),
                name: 'msg',
                meta: {
                  title: '消息详情',
                  requireAuth: true
                }
              },
              {
                path: '/personalSafe',
                component: () => import('@/components/personal/personalSafe'),
                name: 'personalSafe',
                meta: {
                  title: '个人中心',
                  requireAuth: true
                }
              },
              {
                path: '/address',
                component: () => import('@/components/personal/personalAddress'),
                name: 'address',
                meta: {
                  title: '个人中心',
                  requireAuth: true
                }
              },
              {
                path: '/personalmsg',
                component: () => import('@/components/personal/personalmsg'),
                name: 'personalmsg',
                meta: {
                  title: '个人中心',
                  requireAuth: true
                }
              },
              {
                path: '/msgdetail',
                component: () => import('@/components/personal/msgdetail'),
                name: 'msgdetail',
                meta: {
                  title: '个人中心',
                  requireAuth: true
                }
              },
              {
                path: '/myfootprint',
                component: () => import('@/components/personal/myfootprint'),
                name: 'myfootprint',
                meta: {
                  title: '个人中心',
                  requireAuth: true
                }
              },
              {
                path: '/personalOrder',
                component: () => import('@/components/personal/personalOrder'),
                name: 'personalOrder',
                meta: {
                  title: '个人中心',
                  requireAuth: true
                }
              },
              {
                path: '/purchased',
                component: () => import('@/components/personal/purchased'),
                name: 'purchased',
                meta: {
                  title: '个人中心',
                  requireAuth: true
                }
              },
              {
                path: '/exchange',
                component: () => import('@/components/personal/exchange'),
                name: 'exchange',
                meta: {
                  title: '兑换增值服务包',
                  requireAuth: true
                }
              },
              {
                path: '/personalask',
                component: () => import('@/components/personal/personalask'),
                name: 'personalask',
                meta: {
                  title: '个人中心',
                  requireAuth: true
                }
              },
              {
                path: '/personalanswer',
                component: () => import('@/components/personal/personalanswer'),
                name: 'personalanswer',
                meta: {
                  title: '个人中心',
                  requireAuth: true
                }
              },
              {
                path: '/personalValSerPack',
                component: () => import('@/components/personal/personalValSerPack/personalValSerPack'),
                name: 'personalValSerPack',
                meta: {
                  title: '我的增值服务包',
                  requireAuth: true
                }
              },
              {
                path: '/serPackDetail',
                component: () => import('@/components/personal/personalValSerPack/serPackDetail'),
                name: 'serPackDetail',
                meta: {
                  title: '我的增值服务包详情列表',
                  requireAuth: true
                }
              },
              {
                path: '/redeemEbooks',
                component: () => import('@/components/personal/eBooks/redeemEbooks'),
                name: 'redeemEbooks',
                meta: {
                  title: '兑换电子书',
                  requireAuth: true
                }
              },
              {
                path: '/personalRedeemEbooks',
                component: () => import('@/components/personal/eBooks/personalRedeemEbooks'),
                name: 'personalRedeemEbooks',
                meta: {
                  title: '已兑换电子书',
                  requireAuth: true
                }
              },
              {
                path: '/personalcollect',
                component: () => import('@/components/personal/personalcollect'),
                name: 'personalcollect',
                meta: {
                  title: '个人中心',
                  requireAuth: true
                }
              },
              {
                path: '/personalQuan',
                component: () => import('@/components/personal/myReadersCircle/myReadersCircle'),
                name: 'personalQuan',
                meta: {
                  title: '个人中心',
                  requireAuth: true
                }
              },
              {
                path: '/myCourse',
                component: () => import('@/components/personal/myCourse/myCourse'),
                name: 'myCourse',
                meta: {
                  title: '个人中心',
                  requireAuth: true
                }
              },
              {
                path: '/teacherApply',
                name:'teacherApply',
                component: () => import('@/components/personal/teacherApply'),
                meta: {
                  title:"教师认证",
                  requireAuth:true,
                }
              },
              {
                path: '/myStudyCourse',
                name:'myStudyCourse',
                component: () => import('@/components/personal/myStudyCourse/myStudyCourse'),
                meta: {
                  title:"我学的课",
                  requireAuth:true,
                }
              },
              {
                path: '/class/invitationCode',
                name:'myStudyCourse',
                component: () => import('@/components/personal/myStudyCourse/myStudyCourse'),
                meta: {
                  title:"我学的课",
                  requireAuth:true,
                }
              },
              {
                path: '/studentsCurriculum',
                name:'myStudyCurriculum',
                component: () => import('@/components/personal/myStudyCourse/studentsCurriculum'),
                meta: {
                  title:"学生课表",
                  requireAuth:true,
                }
              },
              {
                path: '/myCurriculum',
                component: () => import('@/components/personal/myCourse/myCurriculum'),
                name: 'myCurriculum',
                meta: {
                  title: '教师课表',
                  requireAuth: true
                }
              },
              {
                path: '/addCourse',
                component: () => import('@/components/personal/myCourse/addCourse'),
                name: 'addCourse',
                meta: {
                  title: '教师课表',
                  requireAuth: true
                }
              },
              {
                path: '/mechanism',
                component: () => import('@/components/personal/mechanism'),
                name: 'mechanism',
                meta: {
                  title: '个人中心',
                  requireAuth: true
                }
              },
              {
                path: '/gwc',
                component: () => import('@/components/personal/gwc'),
                name: 'gwc',
                meta: {
                  title: '个人中心',
                  requireAuth: true
                }
              },
              {
                path: '/mypoints',
                component: () => import('@/components/personal/personalMyPoints/userpoints'),
                name: 'personalpoints',
                meta: {
                  title: '我的积分',
                  requireAuth: true
                }
              },
              // {
              //   path: '/userpoints',
              //   component: () => import('@/components/personal/personalMyPoints/userpoints'),
              //   name: 'userpoints',
              //   meta: {
              //     title: '我的积分',
              //     requireAuth: true
              //   }
              // },
              {
                path: '/earnPoints',
                name:'earnPoints',
                component: () => import('@/components/personal/earnPoints/earnPoints'),
                meta: {
                  title:"赚积分",
                  requireAuth:true,
                }
              },
              {
                path: '/pointsQuestion',
                name:'pointsQuestion',
                component: () => import('@/components/personal/personalMyPoints/pointsQuestion'),
                meta: {
                  title:"积分问题",
                  requireAuth:true,
                }
              },
              
          ]
        },
       {
          path: '/pointsMall',
          name:'pointsMall',
          component: () => import('@/components/personal/points-mall/points-mall'),
          meta: {
            title:"积分商城",
            requireAuth:true,
          }
        },
        {
          path: '/studentCourseDetail',
          name:'studentCourseDetail',
          component: () => import('@/components/digitalTextbooks/students/studentCourseDetail/studentCourseDetail'),
          meta: {
            title:"我学的课-课程详情",
            requireAuth:true,
          }
        },
        {
            path: '/teacherCourseDetail',
            name:'teacherCourseDetail',
            component: () => import('@/components/digitalTextbooks/teacher/teacherCourseDetail/teacherCourseDetail'),
            meta: {
              title:"我教的课-课程详情",
              requireAuth:true,
            }
          },
          {
            path: '/signInDetail',
            name:'signInDetail',
            component: () => import('@/components/digitalTextbooks/teacher/teacherCourseDetail/signInDetail'),
            meta: {
              title:"我教的课-签到详情",
              requireAuth:true,
            }
          },
          {
            path: '/studentManageDetail',
            name:'studentManageDetail',
            component: () => import('@/components/digitalTextbooks/teacher/teacherCourseDetail/studentManageDetail'),
            meta: {
              title:"我教的课-学生管理",
              requireAuth:true,
            }
          },
          {
            path: '/classSort',
            name:'classSort',
            component: () => import('@/components/digitalTextbooks/teacher/teacherCourseDetail/classSort'),
            meta: {
              title:"我教的课-班级管理",
              requireAuth:true,
            }
          },
          {
            path: '/coursewareSort',
            name:'coursewareSort',
            component: () => import('@/components/digitalTextbooks/teacher/teacherCourseDetail/coursewareSort'),
            meta: {
              title:"我教的课-课件管理",
              requireAuth:true,
            }
          },
      ]
      
    },
    
    
    {
      path: '/activity',
      component: () => import('@/components/activity/activity'),
      name: 'activity'
    },
    {
      path: '/search',
      component: () => import('@/components/search/search'),
      name: 'search'
    },
    {
      path: '/route',
      component: () => import('@/components/route/route'),
      name: 'route'
    },
    {
      path: '/askcasedetail',
      component: () => import('@/components/asking/askcasedetail'),
      name: 'askcasedetail'
    }, {
      path: '/vip',
      component: () => import('@/components/vip/vip'),
      name: 'vip',
      meta: {
        title: 'VIP',
        requireAuth: true
      }
    }, 
    {
      path: '/moAccount',
      component: () => import('@/components/accountMobile/account'),
      name: 'moAccount',
      meta: {
        title: '确认订单',
        requireAuth: true
      }
    }, 
    {
      path: '/account',
      component: () => import('@/components/account/account'),
      name: 'account',
      meta: {
        title: '确认订单',
        requireAuth: true
      }
    },
    {
      path: '/sampleOrder',
      component: () => import('@/components/sampleOrder/sampleOrder'),
      name: 'sampleOrder',
      meta: {
        title: '确认申请',
        requireAuth: true
      }
    },
    {
      path: '/pay',
      component: () => import('@/components/pay/pay'),
      name: 'pay',
      meta: {
        title: '确认支付',
        requireAuth: true
      }
    }, 
    {
      path: '/payList',
      component: () => import('@/components/payList/payList'),
      name: 'payList',
      meta: {
        title: '确认支付',
        requireAuth: true
      }
    },
    {
      path: '/aliPay',
      component: () => import('@/components/pay/aliPay'),
      name: 'aliPay',
      meta: {
        title: '支付宝支付',
        requireAuth: true
      }
    },
    {
      path: '/paySuccess',
      component: () => import('@/components/pay/paySuccess'),
      name: 'paySuccess',
      meta: {
        title: '支付成功页',
        requireAuth: true
      }
    },
    {
      path: '/cashier',
      component: () => import('@/components/pay/cashier'),
      name: 'cashier',
      meta: {
        title: '收银台',
        requireAuth: true
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js